import React from 'react'
import { useTranslation } from 'react-i18next'
import { PillButton } from '../../../lib/buttons'

export default function OnlineEventButton({ emphasis = 'high' }) {
  const [t] = useTranslation()

  return (
    <PillButton emphasis={emphasis} to="/registration/online/" linkName="Heading: Online Event">
      {t('event.reg.attend.virtual.register', 'Online Event')}
    </PillButton>
  )
}
